/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_TitleInputs */

const cs_ebr_conn_title = /** @type {(inputs: Ebr_Conn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojení k eBráně`)
};

const en_ebr_conn_title = /** @type {(inputs: Ebr_Conn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eBrána connection`)
};

/**
* | output |
* | --- |
* | "eBrána connection" |
*
* @param {Ebr_Conn_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_title = /** @type {((inputs?: Ebr_Conn_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_title(inputs)
	return cs_ebr_conn_title(inputs)
});